import { ReactComponent as Icon } from './raw/Misc_suitcase.svg'
import { SvgIcon, SvgIconProps } from "@mui/material";

const MiscIcon = (props: SvgIconProps) => {
    return (
      <SvgIcon {...props}>
        <Icon />
      </SvgIcon>
    );
  }

export default MiscIcon;